import { FormikHelpers } from 'formik'
import { GetEvaluationFormQuery } from 'generated/resources/graphql'
import { isEmpty, set } from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { FormErrors, useForm } from 'modules/core/hooks/useForm'
import { Result } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

type AtsEvaluationFormQuestion = NonNullable<
  NonNullable<NonNullable<GetEvaluationFormQuery['ats']>['evaluationForm']>['questions']
>[0]

export interface EvaluationFormValues {
  name: string
  questions: AtsEvaluationFormQuestion[]
  atsJobPostingId?: number
  basedOnId?: number
  duplicate?: boolean
}

export type EvaluationFormErrors = FormErrors<EvaluationFormValues>
export type EvaluationFormQuestionError = FormErrors<AtsEvaluationFormQuestion>

export const buildEmptyQuestion = () => ({
  id: uuidv4(),
  text: '',
  description: '',
})

interface FormProps {
  defaultValues: EvaluationFormValues
  onSubmit: (
    values: EvaluationFormValues,
    formikHelpers: FormikHelpers<EvaluationFormValues>
  ) => Promise<Result<unknown>>
}

export function useEvaluationFormForm({ defaultValues, onSubmit }: FormProps) {
  const form = useForm<EvaluationFormValues>({
    defaultValues,
    validate(data) {
      const errors: EvaluationFormErrors = {}

      if (!data.name) {
        errors.name = i18n.t('common.validations.empty')
      }

      data.questions.forEach((question, index) => {
        if (isEmpty(question.text)) {
          set(errors, `questions[${index}].text`, i18n.t('common.validations.empty'))
        }
      })

      return errors
    },
    onSubmit,
  })

  const hasInvalidQuestions = form.values.questions.some((question) => isEmpty(question.text))

  return {
    form,
    hasInvalidQuestions,
  }
}
